<template>
  <component
    :is="componentName"
    :to="item.route"
    :href="item.link"
    v-bind="$attrs"
    style="cursor: pointer;"
    v-on="$listeners"
  >
    <span
      class="text-lg-bold mod--nav"
      v-text="item.label"
    />
  </component>
</template>

<script>
const getComponent = ({ item }) => {
  if (item.route) {
    return 'router-link'
  }
  return 'a'
}
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    componentName() {
      return getComponent(this)
    },
  },
}
</script>
